import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Review } from 'voxloud-types/dist/models/reviews';

@Component({
  selector: 'gdp-review-details-popup',
  templateUrl: './review-details-popup.component.html',
  styleUrls: ['./review-details-popup.component.scss']
})
export class ReviewDetailsPopupComponent implements OnInit {
  public review: Review;
  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.activeModal.close();
  }

}
